/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";

const subscriptionContractTranslations = {
  label: "Abonnement",
  wasDeceived: {
    label: "Täuschung bei Abschluss?",
    options: {
      true: { label: "Ja" },
      false: { label: "Nein" },
    },
  },
  salesChannel: {
    label: "Wo abgeschlossen?",
    options: {
      phone: { label: "Per Telefon" },
      online: { label: "Im Internet" },
      other: { label: "Anderswo" },
    },
  },
  subscriptionName: {
    label: "Name des Abonnements",
  },
  contractNumber: {
    question: "Wie lautet Ihre Vertragsnummer?",
    label: "Vertragsnummer",
    helperText: "Wenn Ihnen keine Vertragsnummer vorliegt, lassen Sie das Feld gerne einfach leer.",
  },
  ...abstractContractClaimTranslations,
};

export default subscriptionContractTranslations;
